import * as PIXI from 'pixi.js';

import GameManager from '@/assets/js/game/GameManager';
import TextureManager from '@/assets/js/game/TextureManager';

export default class AreaObject {
  constructor(id, width, height, x, y, image) {
    this.id = id;
    this.width = width;
    this.height = height;
    this.x = x;
    this.y = y;

    this.container = new PIXI.Container();

    this.initalizeSprite(image);
    this.hitArea = new PIXI.Graphics();
    this.setSize();
    this.container.addChild(this.sprite);
    this.container.addChild(this.hitArea);
  }

  onResize() {
    this.setSize();
  }

  initalizeSprite(image) {
    const isArray = Array.isArray(image);
    if (isArray) {
      const textureList = [];
      for (let i = 0; i < image.length; i++) {
        const texture = TextureManager.get(`${this.id}_${i}`);
        textureList.push(texture);
      }
      this.sprite = new PIXI.AnimatedSprite(textureList);
      this.sprite.animationSpeed = 0.1;
      this.sprite.play();
    } else {
      const texture = TextureManager.get(`${this.id}`);
      this.sprite = new PIXI.Sprite(texture);
    }
  }

  setSize() {
    this.setSpriteSize();
    this.setHitAreaSize();
  }

  setSpriteSize() {
    this.sprite.width = GameManager.calcRatio(this.width);
    this.sprite.height = GameManager.calcRatio(this.height);
    this.sprite.x = GameManager.calcRatio(this.x) - this.sprite.width * 0.5;
    this.sprite.y = GameManager.calcRatio(this.y) - this.sprite.height * 0.5;
  }

  setHitAreaSize() {}

  update(delta, viewPositionX) {}
}
